import { render, staticRenderFns } from "./vue-ladda.vue?vue&type=template&id=a69feed4&"
import script from "./vue-ladda.vue?vue&type=script&lang=js&"
export * from "./vue-ladda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports